/* Gogo Language Texts

Table of Contents

01.General
02.User Login, Logout, Register
03.Menu
04.Dashboards
05.Pages
06.Applications
  06.01.Chat
  06.02.Survey
  06.03.Todo
07.UI
  07.01.Alerts
  07.02.Badges
  07.03.Buttons
  07.04.Cards
  07.05.Carousel
  07.06.Charts
  07.07.Collapse
  07.08.Dropdowns
  07.09.Editors
  07.10.Forms
  07.11.Form Components
  07.12.Icons
  07.13.Input Groups
  07.14.Jumbotron
  07.15.Modal
  07.16.Navigation
  07.17.Popover & Tooltip
  07.18.Sortable
  07.19.Maps
  07.20.Tables
*/

const fiMessages = {
  /* 01.General */
  'general.copyright': 'Myma.ai © 2019 All Rights Reserved.',

  /* 02.User Login, Logout, Register */

  'user.login-title': 'Kirjaudu sisään',
  'user.register': 'Rekisteröidy',
  'user.forgot-password': 'Unohditko salasanan',
  'user.email': 'Sähköposti',
  'user.newpassword': 'Uusi salasana',
  'user.currentpassword': 'Nykyinen salasana',
  'user.newpasswordagain': 'Uusi salasana uudelleen',
  'user.password': 'Salasana',
  'user.forgot-password-question': 'Unohditko salasanan?',
  'user.fullname': 'Koko nimi',
  'user.firstname': 'Etunimi',
  'user.lastname': 'Sukunimi',
  'user.login-button': 'KIRJAUDU SISÄÄN',
  'user.register-button': 'REKISTERÖIDY',
  'user.reset-password-button': 'NOLLAA',
  'user.buy': 'OSTA',
  'user.username': 'Käyttäjätunnus',

  /* 03.Menu */
  'menu.app': 'Koti',
  'menu.default': 'Oletus',
  'menu.analytics': 'Analytiikka',
  'menu.ecommerce': 'Verkkokauppa',
  'menu.content': 'Sisältö',
  'menu.pages': 'Sivut',
  'menu.data-list': 'Tietolista',
  'menu.thumb-list': 'Pikkukuvalista',
  'menu.image-list': 'Kuvien lista',
  'menu.details': 'Tiedot',
  'menu.search': 'Haku',
  'menu.login': 'Kirjaudu sisään',
  'menu.register': 'Rekisteröidy',
  'menu.forgot-password': 'Unohditko salasanan',
  'menu.error': 'Virhe',
  'menu.applications': 'Sovellukset',
  'menu.todo': 'Tehtävälista',
  'menu.survey': 'Kysely',
  'menu.chat': 'Chat',
  'menu.ui': 'Käyttöliittymä',
  'menu.edit': 'Muokkaa',
  'menu.alerts': 'Ilmoitukset',
  'menu.badges': 'Merkinnät',
  'menu.buttons': 'Painikkeet',
  'menu.cards': 'Kortit',
  'menu.carousel': 'Karuselli',
  'menu.charts': 'Kaaviot',
  'menu.collapse': 'Kutista',
  'menu.dropdowns': 'Pudotusvalikot',
  'menu.editors': 'Editorit',
  'menu.form-layouts': 'Lomakkeen asettelut',
  'menu.form-components': 'Lomakekomponentit',
  'menu.form-validations': 'Lomakkeen validoinnit',
  'menu.icons': 'Ikoonit',
  'menu.input-groups': 'Syöteryhmät',
  'menu.jumbotron': 'Jumbotron',
  'menu.modal': 'Modal',
  'menu.navigation': 'Navigointi',
  'menu.popover-tooltip': 'Popover & Työkaluvihje',
  'menu.sortable': 'Lajiteltava',
  'menu.tables': 'Taulukot',
  'menu.menu': 'Valikko',
  'menu.subhidden': 'Alipiilotettu',
  'menu.hidden': 'Piilotettu',
  'menu.visible': 'Näkyvissä',
  'menu.maps': 'Kartat',
  'menu.landingpage': 'Laskeutumissivu',
  'menu.multipage-home': 'Monisivuinen etusivu',
  'menu.singlepage-home': 'Yksisivuinen etusivu',
  'menu.about': 'Tietoa',
  'menu.auth-login': 'Autentikointi Kirjaudu',
  'menu.auth-register': 'Autentikointi Rekisteröidy',
  'menu.blog': 'Blogi',
  'menu.blog-detail': 'Blogin tiedot',
  'menu.careers': 'Ura',
  'menu.confirmation': 'Vahvistus',
  'menu.contact': 'Yhteystiedot',
  'menu.docs': 'Dokumentaatio',
  'menu.features': 'Ominaisuudet',
  'menu.prices': 'Hinnat',
  'menu.videos': 'Videot',
  'menu.mailing': 'Postitus',
  'menu.invoice': 'Lasku',
  'menu.blank-page': 'Tulossa pian...',
  'menu.types': 'Valikkotyypit',
  'menu.levels': 'Valikkotasot',
  'menu.third-level-1': 'Kolmannen tason 1',
  'menu.third-level-2': 'Kolmannen tason 2',
  'menu.third-level-3': 'Kolmannen tason 3',

  /* 04.Dashboards */
  'dashboards.update': 'Päivitä',
  'dashboards.save': 'Tallenna',
  'dashboards.name': 'Nimi',
  'dashboards.button': 'Painike',
  'dashboards.visits': 'Vierailut',
  'dashboards.checkAvailability': 'Tarkista saatavuus tai hinnat',
  'dashboards.details': 'Tiedot',
  'dashboards.pending-orders': 'Pending Orders',
  'dashboards.completed-orders': 'Completed Orders',
  'dashboards.refund-requests': 'Refund Requests',
  'dashboards.new-comments': 'New Comments',
  'dashboards.sales': 'Sales',
  'dashboards.orders': 'Orders',
  'dashboards.refunds': 'Refunds',
  'dashboards.recent-orders': 'Recent Orders',
  'dashboards.product-categories': 'Product Categories',
  'dashboards.cakes': 'Cakes',
  'dashboards.tickets': 'Liput',
  'dashboards.calendar': 'Calendar',
  'dashboards.best-sellers': 'Best Sellers',
  'dashboards.per-session': 'Per Session',
  'dashboards.profile-status': 'Profile Status',
  'dashboards.payment-status': 'Payment Status',
  'dashboards.work-progress': 'Work Progress',
  'dashboards.tasks-completed': 'Tasks Completed',
  'dashboards.payments-done': 'Payments Done',
  'dashboards.order-stock': 'Order - Stock',
  'dashboards.categories': 'Categories',
  'dashboards.quick-post': 'Quick Post',
  'dashboards.title': 'Title',
  'dashboards.content': 'Content',
  'dashboards.ticket-count': 'Lippujen määrä',
  'dashboards.commonticketsubmission': 'Yleiset tukipyyntöjen lähetykset',
  'dashboards.category': 'Category',
  'dashboards.save-and-publish': 'Save and Publish',
  'dashboards.top-viewed-posts': 'Top Viewed Posts',
  'dashboards.posts': 'Posts',
  'dashboards.pending-for-publish': 'Pending for publish',
  'dashboards.users': 'Users',
  'dashboards.on-approval-process': 'On approval process',
  'dashboards.alerts': 'Alerts',
  'dashboards.waiting-for-notice': 'Waiting for notice',
  'dashboards.files': 'Files',
  'dashboards.pending-for-print': 'Pending for print',
  'dashboards.logs': 'Logs',
  'dashboards.gogo': 'GOGO',
  'dashboards.magic-is-in-the-details': 'MAGIC IS IN THE DETAILS',
  'dashboards.yes-it-is-indeed': 'Yes, it is indeed!',
  'dashboards.advanced-search': 'Advanced Search',
  'dashboards.toppings': 'Toppings',
  'dashboards.type': 'Type',
  'dashboards.keyword': 'Keyword',
  'dashboards.search': 'Search',
  'dashboards.top-rated-items': 'Top Rated Items',
  'dashboards.country': 'Maa',
  'dashboards.webVisitors': 'Verkkovierailijat',
  'dashboards.avatarClicks': 'Avatarin klikkaukset',
  'dashboards.wordCloud': 'Sanapilvi',
  'dashboards.topic': 'Topic',
  'dashboards.roomsAvailability': 'Huoneet ja saatavuus',
  'dashboards.startChat': 'Aloita keskustelu',
  'dashboards.restaurantsBars': 'Ravintolat ja baarit',
  'dashboards.groupBooking': 'Ryhmävaraus',
  'dashboards.promotions': 'Tarjoukset',
  'dashboards.weedingevents': 'Hääjuhlat & tapahtumat',
  'dashboards.lostsomething': 'Jokin kadonnut',
  'dashboards.producttext': 'Tuoteteksti',
  'dashboards.bookingroomnew': 'Uusi huonevaraus',
  'dashboards.email': 'Sähköposti',
  'dashboards.phone': 'Puhelin',
  'dashboards.zipcode': 'Postinumero',
  'dashboards.marketingconsent': 'Markkinointisuostumus',
  'dashboards.additionalinfo': 'Lisätiedot',
  'dashboards.viewallcontacts': 'Näytä kaikki yhteystiedot',
  'dashboards.current': 'Nykyinen',
  'dashboards.last7days': 'Viimeiset 7 päivää',
  'dashboards.last30days': 'Viimeiset 30 päivää',
  'dashboards.thisweek': 'Tällä viikolla',
  'dashboards.thismonth': 'Tässä kuussa',
  'dashboards.previousmonth': 'Edellinen kuukausi',
  'dashboards.yeartodate': 'Kuluvan vuoden alusta',
  'dashboards.lastyear': 'Viime vuosi',
  'dashboards.all': 'Kaikki',
  'dashboards.standardOccupancy': 'Vakiokapasiteetti',
  'dashboards.max-occupancy': 'Suurin sallittu henkilömäärä',
  'dashboards.numberOfThisType': 'Tämän tyypin määrä',
  'dashboards.displayOrder': 'Näyttöjärjestys',
  'dashboards.provider': 'Palveluntarjoaja',
  'dashboards.edit': 'Muokkaa',
  'dashboards.delete': 'Poista',
  'dashboards.addImages': 'Lisää kuvia',
  'dashboards.location_ip': 'Sijainti on likimääräinen ja määritetty IP‑osoitteen perusteella',
  'dashboards.near': 'Lähellä',
  'dashboards.referral': 'Käyttäjä ohjasi sivullesi tämän verkkosivuston kautta',
  'dashboards.calling_party': 'Soittava osapuoli',
  'dashboards.called_party': 'Vastaanottava osapuoli',
  'dashboards.lastdial': 'Viimeksi valittu',
  'dashboards.imagelink': 'Kuvalinkki',
  'dashboards.browsegallery': 'Selaa galleriaa',
  'dashboards.changelog': 'Muutosloki',
  'dashboards.externalresources': 'Ulkopuoliset resurssit',
  'dashboards.webpage': 'Verkkosivu',
  'dashboards.web-pages': 'Verkkosivut',
  'dashboards.published': 'Julkaistu',
  'dashboards.adddocument': 'Lisää asiakirja',
  'dashboards.ready-to-publish': 'Valmis julkaistavaksi',
  'dashboards.draft': 'Luonnos',
  'dashboards.order-by': 'Järjestä',
  'dashboards.add-faq': 'Lisää UKK',
  'dashboards.collections': 'Kokoelmat',
  'dashboards.items': 'Tuotteet',
  'dashboards.rooms-availability': 'Huoneet ja saatavuus',
  'dashboards.events-wedding-venues': 'Tapahtumat ja hääpaikat',
  'dashboards.long-stay-enquiry': 'Pitkän oleskelun tiedustelu',
  'dashboards.reservation-confirmation-request': 'Varausvahvistuspyyntö',
  'dashboards.modify-cancel-booking': 'Muuta tai peru varaus',
  'dashboards.left-something-behind': 'Unohtanut jotain',
  'dashboards.invoice-copy': 'Laskun / kuitin kopio',
  'dashboards.sync': 'Synkronoi',
  'dashboards.add-web-page': 'Lisää verkkosivu',
  'dashboards.sprint-title': 'Tutustu Sprintiin — läpimurtoautomaatioon, joka kouluttaa tekoälymallin 10× nopeammin.',
  'dashboards.sprint-description': 'Sprint työskentelee rinnallasi — vapauttaen luovuutta, avaten tuottavuuden ja lyhentäen merkittävästi Apu-assistentin koulutusaikaa.',
  'dashboards.sprint-feature': 'Sprint-ominaisuus on suunniteltu synkronoimaan tietoa ulkoisista lähteistä, mikä tekee siitä arvokkaan sekä alkuasetuksissa että jatkuvissa tietopäivityksissä. Kun se suoritetaan aktiivisessa järjestelmässä, Sprint muokkaa Knowledge Hubia määrittelemiesi ulkoisten lähteiden perusteella, mikä voi vaikuttaa suoraan tekoälyn generoimiin käytöksiin ja vastauksiin. Sprintin asetuksessa avustamiseksi ota yhteyttä tukitiimiimme.',
  'dashboards.change-password': 'Vaihda salasana',
  'dashboards.sign-out': 'Kirjaudu ulos',
  'dashboards.privacy-policy': 'Tietosuojakäytäntö',
  'dashboards.help-center': 'Ohjekeskus',
  'dashboards.switch-account': 'Vaihda tili',
  'dashboards.business-settings': 'Yritysasetukset',
  'dashboards.notifications-allowed': 'Ilmoitukset sallittu',
  'dashboards.dark-theme': 'Tumma teema',
  'dashboards.online': 'Verkossa',
  'dashboards.offline': 'Offline-tilassa',
  'dashboards.invoice-&-payments': 'Laskut ja maksut',
  'dashboards.upgrade-plan': 'Päivitä suunnitelma',
  'dashboards.add-room': 'Lisää huone',
  'dashboards.room-type': 'Huonetyyppi',
  'dashboards.room-name': 'Huoneen nimi',
  'dashboards.how-many-guests': 'Kuinka monta vierasta mahtuu tähän huoneeseen?',
  'dashboards.number-of-rooms-this-type': 'Huoneiden määrä (tätä tyyppiä)',
  'dashboards.number-of-bedrooms': 'Makuuhuoneiden määrä',
  'dashboards.number-of-livingrooms': 'Olohuoneiden määrä',
  'dashboards.minimum-adults': 'Vähimmäisaikuisten määrä',
  'dashboards.maximum-adults': 'Enimmäisaikuisten määrä',
  'dashboards.maximum-children': 'Enimmäislapsia',
  'dashboards.maximum-infants': 'Enimmäisvauvoja',
  'dashboards.extra-beds-allowed': 'Lisävuoteet sallittuja',
  'dashboards.booking-engine-code': 'Varausjärjestelmän koodi',
  'dashboards.room-size': 'Huoneen koko',
  'dashboards.balcony-area': 'Parvekkeen ala',
  'dashboards.unit': 'Yksikkö',
  'dashboard.whatsapp_message': 'Kirjoita viestisi tähän...',
  'dashboard.whatsapp_reply_window': 'Sinulla on 24 tunnin aika vastata asiakkaan viestiin WhatsApp Businessissa siitä hetkestä lähtien, kun asiakas on viimeksi lähettänyt viestin. Jos vastaat tämän 24 tunnin asiakaspalveluikkunan aikana, voit lähettää minkä tahansa viestityypin. Kun 24 tunnin ikkuna sulkeutuu, voit lähettää vain ennalta hyväksyttyjä viestimalleja, jotka käynnistävät 24 tunnin ikkunan uudelleen asiakkaan vastatessa.',
  'dashboards.square-meters': 'Neliömetriä',
  "dashboard.pick_quick_reply": "Valitse pikavastaus tai kirjoita viestisi",
  "dashboard.hang_in_there": "Odota hetki, yritämme yhdistää sinut!",
  "dashboard.outbound_msg": "Milloin lähtevä viesti lähetetään",
  "dashboard.message_sent": "Viestisi on lähetetty onnistuneesti!",
  "dashboard.failed_msg": "Viestin lähetys epäonnistui",
  "dashboard.new_chat_message": "Uusi chat-viesti",
  "dashboard.user_msg": "Käyttäjältä on tullut viesti viimeisen 24 tunnin aikana. Voit vastata millä tahansa viestillä. Haluatko silti lähettää tämän malliviestin vai vastata toisella viestillä?",
  "dashboard.us_number": "WhatsApp Business -viestejä ei lähetetä Yhdysvaltain numeroihin, koska Meta keskeytti kaikki markkinointiviestit Yhdysvaltain numeroihin 1. huhtikuuta 2025.",
  "dashboard.error_msg": "Täytä kaikki paikkamerkit oikein.",

  'web-widget.title': 'Verkkosivuston chatbotin widget-valikot',

  /*Home page*/
  'dashboards.quickstartwithai': 'Nopea alku tekoälyn kanssa',
  'dashboards.fastestpathtoautomation': 'Olet nopeimmalla tiellä automaatioon tekoälytyökaluilla',
  'dashboards.insightsthatempower': 'Oivallukset, jotka voimaannuttavat',
  'dashboards.trainchatbot': 'Kouluta chatbot',
  'dashboards.automatewithforms': 'Automatisoi lomakkeilla',
  'dashboards.inroomdigitalcompendium': 'Huoneen digitaalinen tiivistelmä',
  'dashboards.support': 'Tuki',
  'dashboards.helpcenter': 'Ohjekeskus',
  'dashboards.searchfaqintegrations': 'Etsi artikkeleita yleisistä UKK‑kysymyksistä, integraatioista ja muusta.',
  'dashboards.asklivechat': 'Kysy kysymys tiimiltämme Live‑chatissa',
  'dashboards.inroomqrcode': 'Huoneen QR‑koodi näyttää tietoja kiinteistöstä ja sijainnista',
  'dashboards.customizewebwidget': 'Mukauta ja lisää verkkosovellus sivustollesi integroidulla tekoälychatbotilla',
  'dashboards.createcustomforms': 'Luo mukautettuja lomakkeita ja saa ilmoituksia, kun vieras lähettää lomakkeen',
  'dashboards.trainchatbotproperty': 'Kouluta chatbot kiinteistösi tiedoilla kuten sisäänkirjautumisaika, aktiviteetit jne.',
  'dashboards.chatbotinsights': 'Katso, miten chatbot sitouttaa vieraita ja saa tietoa tilastoista kuten verkkosivukävijöistä, usein kysytyistä kysymyksistä ja paljon muusta.',
  'dashboards.addaichatbottoyourwebsite': 'Lisää tekoäly‑chatbot sivustollesi',


  /* Email Stats */
  'dashboards.thread-summary-title': 'Sähköpostiketjujen yhteenvedot',
  'dashboards.thread-summary-subtitle': 'Tekoälyn luomat sähköpostiyhteenvedot',
  'dashboards.ai-replies-title': 'Tekoälyn vastaukset',
  'dashboards.ai-replies-subtitle': 'Tekoälyn tuottamat vastaukset',

  'dashboards.total-thread-summary-title': 'Yhteensä luodut sähköpostiketjujen yhteenvedot',
  'dashboards.total-ai-replies-title': 'Yhteensä luodut tekoälyn vastaukset',
  'dashboards.total-draft-copied': 'Luonnokset kopioitu käyttäjien toimesta',

  'dashboards.urgency': 'Kiireellisyys',
  'dashboards.sentiment': 'Tunne',

  'dashboards.common-email-reasons': 'Yleiset sähköpostin syyt',
  'dashboards.topics-in-emails': 'Sähköpostien aiheet',

  'dashboards.email-assistant-usage': 'Tekoälyavustajan käyttö',
  'dashboards.usage-by-email-address': 'Käyttö sähköpostiosoitteittain',

  /* 05.Pages */
  'pages.title.dashboards.analytics': 'Analytiikka',
  'pages.title.ari': 'Saatavuus ja hinnat',
  'pages.title.conversations': 'Keskustelut',
  'pages.title.bookings': 'Varaukset',
  'pages.title.tickets': 'Liidit ja liput',
  'pages.title.propinfo': 'Vastaukset',
  'pages.title.discounts': 'Alennukset ja kampanjat',
  'pages.title.finance': 'Talous',
  'pages.title.integration': 'Integraatio',
  'pages.title.admin': 'Ylläpito',
  'pages.add-new': 'LISÄÄ UUSI',
  'pages.add-new-modal-title': 'Lisää uusi kohde',
  'pages.display-options': 'Näyttövaihtoehdot',
  'pages.orderby': 'Järjestä: ',
  'pages.product-name': 'Tuotenimi',
  'pages.category': 'Kategoria',
  'pages.description': 'Kuvaus',
  'pages.status': 'Tila',
  'pages.cancel': 'Peruuta',
  'pages.submit': 'Lähetä',
  'pages.delete': 'Poista',
  'pages.another-action': 'Toinen toiminto',
  'pages.actions': 'TOIMINNOT',
  'pages.header': 'Otsikko',
  'pages.details': 'TIEDOT',
  'pages.orders': 'TILAAUKSET',
  'pages.rating': 'Arvostelu',
  'pages.price': 'Hinta',
  'pages.ingredients': 'Ainesosat',
  'pages.is-vegan': 'Onko vegaaninen',
  'pages.order-status': 'Tilausstatus',
  'pages.bake-progress': 'Paistamisen eteneminen',
  'pages.popularity': 'Suosio',
  'pages.comments': 'Kommentit',
  'pages.error-title': 'Hups... virhe tapahtui!',
  'pages.error-code': 'Virhekoodi',
  'pages.go-back-home': 'PALAUTA KOTIIN',
  'pages.mailing-info':
    'Postitusmallit käyttävät sisäisiä tyylejä ja taulukkoasettelua, jotta ne näkyvät hyvin eri palveluntarjoajilla. Parempaa käytettävyyttä varten ne on sisällytetty tavallisena HTML-koodina dangerouslySetInnerHTML:n avulla.',
  'pages.invoice-info':
    'Laskupohjassa on sekä inline-tyylitelty versio käytettäväksi projektin ulkopuolella että React-versio.',
  'pages.react-version': 'React-versio',
  'pages.inline-version': 'Inline-tyylitelty HTML-versio',

  /* 06.Applications */

  /* 06.01.Chat */
  'chat.messages': 'Viestit',
  'chat.contacts': 'Yhteystiedot',
  'chat.saysomething': 'Sano jotain..',

  /* 06.02.Survey */
  'survey.delete': 'Poistaa',
  'survey.edit': 'Muokata',
  'survey.add-new': 'LISÄÄ UUSI',
  'survey.add-new-title': 'Lisää uusi kysely',
  'survey.title': 'Otsikko',
  'survey.category': 'Kategoria',
  'survey.label': 'Label',
  'survey.status': 'Tila',
  'survey.cancel': 'Peruuttaa',
  'survey.submit': 'Lähetä',
  'survey.another-action': 'Toinen toiminto',
  'survey.display-options': 'Näyttövaihtoehdot',
  'survey.orderby': 'Järjestä: ',
  'survey.all-surveys': 'Kaikki kyselyt',
  'survey.completed-surveys': 'Valmiit kyselyt',
  'survey.categories': 'Kategoriat',
  'survey.active-surveys': 'Aktiiviset kyselyt',
  'survey.labels': 'Tunnisteet',

  /* 06.03.Todo */
  'todo.add-new': 'LISÄÄ UUSI',
  'todo.add-new-title': 'Lisää uusi tehtävä',
  'todo.title': 'Otsikko',
  'todo.detail': 'Yksityiskohdat',
  'todo.category': 'Kategoria',
  'todo.label': 'Tunniste',
  'todo.status': 'Tila',
  'todo.cancel': 'Peruuta',
  'todo.submit': 'Lähetä',
  'todo.action': 'Toiminto',
  'todo.another-action': 'Toinen toiminto',
  'todo.display-options': 'Näyttövaihtoehdot',
  'todo.orderby': 'Järjestä: ',
  'todo.all-tasks': 'Kaikki tehtävät',
  'todo.pending-tasks': 'Odotettavat tehtävät',
  'todo.completed-tasks': 'Valmiit tehtävät',
  'todo.categories': 'Kategoriat',
  'todo.labels': 'Tunnisteet',

  /* 07.UI */

  /* 07.01.Alerts */
  'alert.rounded': 'Pyöristetty ilmoitus',
  'alert.react-notifications': 'React-ilmoitukset',
  'alert.outline': 'Reunaviiva',
  'alert.primary': 'Pääasiallinen',
  'alert.secondary': 'Toissijainen',
  'alert.info': 'Info',
  'alert.success': 'Onnistui',
  'alert.warning': 'Varoitus',
  'alert.error': 'Virhe',
  'alert.filled': 'Täytetty',
  'alert.primary-text': 'Tämä on pääasiallinen ilmoitus—tarkista se!',
  'alert.secondary-text': 'Tämä on toissijainen ilmoitus—tarkista se!',
  'alert.success-text': 'Tämä on onnistumisilmoitus—tarkista se!',
  'alert.danger-text': 'Tämä on vaarailmoitus—tarkista se!',
  'alert.warning-text': 'Tämä on varoitusilmoitus—tarkista se!',
  'alert.info-text': 'Tämä on infoilmoitus—tarkista se!',
  'alert.light-text': 'Tämä on kevyt ilmoitus—tarkista se!',
  'alert.dark-text': 'Tämä on tumma ilmoitus—tarkista se!',
  'alert.default': 'Oletusilmoitus',
  'alert.dismissing': 'Sulkeutuva ilmoitus',
  'alert.dismissing-text': 'Hei! Kannattaa tarkistaa jotkin kentät alla.',
  'alert.dismissing-without-animate-text': 'Olen ilmoitus ja voin sulkeutua ilman animaatiota!',

  /* 07.02.Badges */
  'badge.sizes': 'Koot',
  'badge.colors': 'Värit',
  'badge.outline': 'Reunaviiva',
  'badge.links': 'Linkit',
  'badge.counter-badges': 'Laskurimerkinnät',
  'badge.bootstrap-default': 'Bootstrap-oletus',
  'badge.primary': 'Pääasiallinen',
  'badge.secondary': 'Toissijainen',
  'badge.success': 'Onnistui',
  'badge.danger': 'Vaara',
  'badge.warning': 'Varoitus',
  'badge.info': 'Info',
  'badge.light': 'Vaalea',
  'badge.dark': 'Tumma',

  /* 07.03.Buttons */
  'button.default': 'Bootstrap-oletus',
  'button.colors': 'Värit',
  'button.rounded': 'Pyöristetty',
  'button.outline': 'Reunaviiva',
  'button.states': 'Tilat',
  'button.sizes': 'Koot',
  'button.button-groups': 'Painikeryhmät',
  'button.large-button': 'Suuri painike',
  'button.small-button': 'Pieni painike',
  'button.extra-small-button': 'Erittäin pieni painike',
  'button.block-button': 'Lohkopainike',
  'button.active': 'Aktiivinen',
  'button.disabled': 'Pois käytöstä',
  'button.basic': 'Perus',
  'button.toolbar': 'Työkalupalkki',
  'button.nesting': 'Sisäkkäisyys',
  'button.vertical-variation': 'Pystysuuntainen muunnelma',
  'button.checkbox-radio-button': 'Valintaruutu ja valintanappi',
  'button.checkbox': 'Valintaruutu',
  'button.radio': 'Valintanappi',
  'button.radio-button': 'Valintanappi',
  'button.primary': 'Pääasiallinen',
  'button.secondary': 'Toissijainen',
  'button.success': 'Onnistui',
  'button.danger': 'Vaara',
  'button.warning': 'Varoitus',
  'button.info': 'Info',
  'button.light': 'Vaalea',
  'button.dark': 'Tumma',
  'button.states-text':
    'Tämä painike näyttää pyörivän indikaattorin 2 sekuntia ja virhekuvakkeen 3 sekuntia ennen paluuta normaaliin tilaan. Näitä tiloja voidaan ohjata luokkien lisäämisellä ja poistamisella.',
  'button.click-here': 'Klikkaa tästä',
  'button.states-text-alternate':
    'Tämä painike näyttää pyörivän indikaattorin 2 sekuntia ja virhekuvakkeen 3 sekuntia ennen paluuta normaaliin tilaan. Näitä tiloja voidaan ohjata luokkien lisäämisellä ja poistamisella.',
  'button.primary-link': 'Päälinkki',
  'button.link': 'Linkki',
  'button.primary-button': 'Pääpainike',
  'button.button': 'Painike',
  'button.left': 'Vasen',
  'button.middle': 'Keskellä',
  'button.right': 'Oikea',
  'button.dropdown': 'Pudotusvalikko',
  'button.dropdown-link': 'Pudotusvalikon linkki',


  /* 07.04.Cards */
  'cards.icon-card': 'Ikonikortti',
  'cards.image-card': 'Kuvakortti',
  'cards.image-overlay-card': 'Kuvapäällekkäiskortti',
  'cards.image-card-list': 'Kuvakorttilista',
  'cards.tab-card': 'Välilehtikortti',
  'cards.user-card': 'Käyttäjäkortti',

  /* 07.05.Carousel */
  'carousel.basic': 'Perus karuselli',
  'carousel.single': 'Yksittäinen karuselli',
  'carousel.without-controls': 'Karuselli ilman ohjaimia',

  /* 07.06.Charts */
  'charts.line': 'Viivakaavio',
  'charts.polar': 'Polaarikaavio',
  'charts.area': 'Aluekaavio',
  'charts.scatter': 'Hajontakaavio',
  'charts.bar': 'Pylväskaavio',
  'charts.radar': 'Häkkikaavio',
  'charts.pie': 'Piirakkakaavio',
  'charts.doughnut': 'Donitsikaavio',
  'charts.shadow': 'Varjo',
  'charts.no-shadow': 'Ei varjoa',

  /* 07.07.Collapse */
  'collapse.basic': 'Perus',
  'collapse.toggle': 'Vaihda',
  'collapse.accordion': 'Harmonikkanäkymä',
  'collapse.controlled': 'Ohjattu',
  'collapse.uncontrolled': 'Ohjaamaton',

  /* 07.08.Dropdowns */
  'dropdowns.basic': 'Perus',
  'dropdowns.controlled': 'Ohjattu',
  'dropdowns.uncontrolled': 'Ohjaamaton',
  'dropdowns.dropdown': 'Pudotusvalikko',
  'dropdowns.header': 'Otsikko',
  'dropdowns.action': 'Toiminto',
  'dropdowns.another-action': 'Toinen toiminto',
  'dropdowns.right': 'Oikea',
  'dropdowns.left': 'Vasen',
  'dropdowns.drop-directions': 'Pudotussuunnat',
  'dropdowns.dropright': 'Pudotus oikealle',
  'dropdowns.dropleft': 'Pudotus vasemmalle',
  'dropdowns.small-button': 'Pieni painike',
  'dropdowns.large-button': 'Iso painike',
  'dropdowns.sizing': 'Koko',
  'dropdowns.split-button': 'Jaetut painikkeet',
  'dropdowns.dropup': 'Pudotus ylöspäin',

  /* 07.09.Editors */
  'editors.draftjs': 'Draft.js',
  'editors.quill-standart': 'Quill Standard',
  'editors.quill-bubble': 'Quill Bubble',

  /* 07.10.Forms */
  'forms.basic': 'Perus',
  'forms.email': 'Sähköposti',
  'forms.email-muted': 'Emme koskaan jaa sähköpostiasi kenellekään.',
  'forms.password': 'Salasana',
  'forms.submit': 'Lähetä',
  'forms.horizontal': 'Vaaka',
  'forms.radios': 'Valintanapit',
  'forms.first-radio': 'Ensimmäinen valintanappi',
  'forms.second-radio': 'Toinen valintanappi',
  'forms.third-radio-disabled': 'Kolmas pois käytöstä oleva valintanappi',
  'forms.checkbox': 'Valintaruutu',
  'forms.signin': 'Kirjaudu sisään',
  'forms.top-labels-over-line': 'Ylälabelit linjan yläpuolella',
  'forms.tags': 'Tunnisteet',
  'forms.date': 'Päivämäärä',
  'forms.state': 'Osavaltio',
  'forms.top-labels-in-input': 'Ylälabelit syöttökentässä',
  'forms.email-u': 'SÄHKÖPOSTI',
  'forms.password-u': 'SALASANA',
  'forms.tags-u': 'TUNNISTEET',
  'forms.date-u': 'PÄIVÄMÄÄRÄ',
  'forms.state-u': 'OSAVALTIOT',
  'forms.grid': 'Lomakeverkko',
  'forms.address': 'Osoite',
  'forms.address2': 'Osoite 2',
  'forms.city': 'Kaupunki',
  'forms.city-message': 'Valitse kaupunki!',
  'forms.state-message': 'Valitse osavaltio!',
  'forms.zip': 'Postinumero',
  'forms.signup': 'Rekisteröidy',
  'forms.inline': 'Rivissä',
  'forms.validation-availity': 'Availity Reactstrap -validointi',
  'forms.validation-formik': 'Formik-validointi',
  'forms.default': 'Oletus',
  'forms.firstname': 'Etunimi',
  'forms.firstname-message': 'Syötä etunimesi!',
  'forms.lastname': 'Sukunimi',
  'forms.lastname-message': 'Syötä sukunimesi!',

  /* 07.11.Form Components */
  'form-components.custom-inputs': 'Mukautetut syötteet',
  'form-components.checkboxes': 'Valintaruudut',
  'form-components.radios': 'Valintanapit',
  'form-components.inline': 'Rivissä',
  'form-components.react-select': 'React Select',
  'form-components.state-single': 'Yksittäinen osavaltio',
  'form-components.state-multiple': 'Useampi osavaltio',
  'form-components.react-autosuggest': 'React Autosuggest',
  'form-components.date-picker': 'Päivämäärän valitsin',
  'form-components.date': 'Päivämäärä',
  'form-components.date-range': 'Päivämääräväli',
  'form-components.date-with-time': 'Päivämäärä ja aika',
  'form-components.embedded': 'Upotettu',
  'form-components.dropzone': 'Tiputusalue',
  'form-components.drop-files-here': 'Pudota tiedostot tähän',
  'form-components.tags': 'Tunnisteet',
  'form-components.switch': 'Kytkin',
  'form-components.primary': 'Ensisijainen',
  'form-components.secondary': 'Toissijainen',
  'form-components.primary-inverse': 'Ensisijainen käänteinen',
  'form-components.secondary-inverse': 'Toissijainen käänteinen',
  'form-components.slider': 'Liukusäädin',
  'form-components.double-slider': 'Kaksoisliukusäädin',
  'form-components.single-slider': 'Yksittäinen liukusäädin',
  'form-components.rating': 'Arvostelu',
  'form-components.interactive': 'Interaktiivinen',
  'form-components.readonly': 'Vain luku',
  'form-components.type-a-cake': 'Kirjoita kakku',
  'form-components.start': 'Aloita',
  'form-components.end': 'Lopeta',
  'form-components.tables': 'Taulukot',

  /* 07.12.Icons */
  'icons.simplelineicons': 'Simple Line -ikonit',
  'icons.iconsmind': 'Iconsmind-ikonit',

  /* 07.13.Input Groups */
  'input-groups.basic': 'Perus',
  'input-groups.sizing': 'Koko',
  'input-groups.small': 'Pieni',
  'input-groups.default': 'Oletus',
  'input-groups.large': 'Iso',
  'input-groups.checkboxes-and-radios': 'Valintaruudut ja valintanapit',
  'input-groups.multiple-inputs': 'Useita syötteitä',
  'input-groups.first-and-last-name': 'Etunimi ja sukunimi',
  'input-groups.multiple-addons': 'Useita lisäosia',
  'input-groups.button-addons': 'Painikkeen lisäosat',
  'input-groups.button': 'Painike',
  'input-groups.buttons-with-dropdowns': 'Painikkeet pudotusvalikoilla',
  'input-groups.dropdown': 'Pudotusvalikko',
  'input-groups.header': 'Otsikko',
  'input-groups.action': 'Toiminto',
  'input-groups.another-action': 'Toinen toiminto',
  'input-groups.custom-select': 'Mukautettu valinta',
  'input-groups.options': 'Vaihtoehdot',
  'input-groups.choose': 'Valitse...',
  'input-groups.custom-file-input': 'Mukautettu tiedostosyöte',

  /* 07.14.Jumbotron */
  'jumbotron.hello-world': 'Hei maailma!',
  'jumbotron.lead': 'Tämä on yksinkertainen hero-yksikkö, yksinkertainen jumbotron-tyylinen komponentti, joka kiinnittää ylimääräistä huomiota esiteltyyn sisältöön tai tietoon.',
  'jumbotron.lead-detail': 'Se käyttää apuluokkia typografian ja välistyksen hallintaan isomman säiliön sisällä.',
  'jumbotron.learn-more': 'Lue lisää',

  /* 07.15.Modal */
  'modal.basic': 'Perus',
  'modal.modal-title': 'Modaalin otsikko',
  'modal.launch-demo-modal': 'Käynnistä demomodaali',
  'modal.scrolling-long-content': 'Pitkä vieritettävä sisältö',
  'modal.backdrop': 'Taustakangas',
  'modal.backdrop-value': 'Taustakankaan arvo',
  'modal.right-modal': 'Oikea modaali',
  'modal.launch-right-modal': 'Käynnistä oikea modaali',
  'modal.nested-modal': 'Sisäkkäinen modaali',
  'modal.size': 'Koko',
  'modal.launch-large-modal': 'Käynnistä iso modaali',
  'modal.launch-small-modal': 'Käynnistä pieni modaali',

  /* 07.16.Navigation */
  'nav.basic': 'Perusvalikko',
  'nav.active': 'Aktiivinen',
  'nav.disabled': 'Poissa käytöstä',
  'nav.disabled-link': 'Poissa käytöstä oleva linkki',
  'nav.link': 'Linkki',
  'nav.longer-link': 'Pidempi linkki',
  'nav.another-link': 'Toinen linkki',
  'nav.right': 'Oikea',
  'nav.dropdown': 'Pudotusvalikko',
  'nav.header': 'Otsikko',
  'nav.action': 'Toiminto',
  'nav.another-action': 'Toinen toiminto',
  'nav.horizontal-alignment': 'Vaakasuuntainen tasaus',
  'nav.vertical-alignment': 'Pystysuuntainen tasaus',
  'nav.pills': 'Valintanapit',
  'nav.fill-justify': 'Täytä ja tasaus',
  'nav.pills-dropdowns': 'Valintanapit pudotusvalikoilla',
  'nav.pagination-basic': 'Perus sivutus',
  'nav.pagination-sizing': 'Sivutuksen koko',
  'nav.large': 'Iso',
  'nav.small': 'Pieni',
  'nav.center': 'Keskitä',
  'nav.pagination-alignment': 'Sivutuksen tasaus',
  'nav.breadcrumb-basic': 'Perus leipäpolku',

  /* 07.17.Popover & Tooltip */
  'popover-tooltip.popover': 'Popover',
  'popover-tooltip.tooltip': 'Työkaluvinkki',

  /* 07.18.Sortable */
  'sortable.columns': 'Sarakkeiden lajittelu',
  'sortable.basic': 'Perus',
  'sortable.handles': 'Kahvat',

  /* 07.19.Maps */
  'maps.google': 'Google',
  'maps.yandex': 'Yandex',

  /* 07.20.Tables */
  'table.bootstrap-tables': 'Bootstrap-taulukot',
  'table.bootstrap-basic': 'Perustaulukko',
  'table.bootstrap-striped': 'Raidalliset rivit',
  'table.bootstrap-bordered': 'Reunattu taulukko',
  'table.bootstrap-borderless': 'Reunaton pöytä',
  'table.bootstrap-hoverable': 'Liukuvat rivit',
  'table.bootstrap-responsive': 'Responsiivinen taulukko',
  'table.react-tables': 'Reaktiotaulukot',
  'table.react-pagination': 'Sivunumerointi',
  'table.react-scrollable': 'vieritettävä',
  'table.react-advanced': 'Suodata, pituus ja hyppy',

  /* Property Info */
  "property-info.allcustomers": 'Kaikki asiakkaa',
  'property-info.external-sources': 'Ulkopuoliset lähteet',
  'property-info.faq': 'Usein kysytyt kysymykset',
  'property-info.documents': 'Asiakirjat',
  'property-info.publish-ai': 'Julkaise tekoälyllä',
  'property-info.pre-built-templates': 'Valmiit mallit',
  'property-info.room-types': 'Huonetyypit',

  'property-info.about-property': 'Tietoja omaisuudesta',
  'property-info.about-properties': 'Tietoja ominaisuuksista',
  'property-info.facilities-services': 'Tilat ja palvelut',
  'property-info.property-facilities': 'Kiinteistön tilat',
  'property-info.room-amenities': 'Huoneen mukavuudet',
  'property-info.property-contact': 'Kiinteistön yhteystiedot',
  'property-info.property-activities': 'Kiinteistöalan toiminta',
  'property-info.property-location': 'Kiinteistön sijainti',
  'property-info.about-rooms': 'Tietoja Huoneista',
  'property-info.about-sites': 'Tietoja sivustoista',
  'property-info.special-emergencies': 'Hätätilanteet',
  'property-info.gallery': 'Galleria',
  'property-info.policies': 'Käytännöt',
  'property-info.nearby': 'Lähistöllä',
  'property-info.transport': 'Kuljetus',
  'property-info.location': 'Sijainti',
  'property-info.about-rhproperty': 'Tietoja vanhainkodista',
  'property-info.related-topics': 'Liittyvät aiheet',
  'property-info.assistant-options': 'Assistant-valikko',
  'property-info.restaurant-assistant-information': 'Ravintolan tiedot',
  'property-info.restaurant-assistant-options': 'Tervetuloviesti',
  'property-info.channel-messages': 'Kanavan viestit',
  'property-info.icon.gallery': 'Ikoni galleria',
  'property-info.copilot': 'Lentoperämies',
  'property-info.sprint': 'Sprintti',
  'property-info.home-information': 'Kotitiedot',
  'property-info.loction': 'Sijainnit',
  'property-info.rooms-and-images': 'Huoneet ja kuvat',
  'property-info.trainig-data': 'Koulutustiedot',
  'property-info.flows': 'Virtaukset',
  'property-info.add-your-own': 'Lisää omasi',
  'property-info-utility-miscellaneous': 'Sekalaista',
  'property-info-utility-payment': 'Maksut',
  'property-info-utility-broadband': 'Laajakaista',
  'property-info-utility-emergency': 'Hätä',
  'property-info-utility-mobile': 'mobiili',
  'property-info-utility-moving': 'Liikkuva',
  'property-info.publishMonitor': 'Julkaise ja seuraa',
  'property-info.webWidget': 'Verkkovimpain',
  'property-info.media': 'Media',
  /** Rate & Promo */
  'rate-promo.rate-plans': 'Hintasuunnitelmat',
  'rate-promo.rate-plan-addons': 'Lisäosat',
  'rate-promo.rate-plan-promos': 'Kampanjat',

  'title.property-information': 'Kiinteistön tiedot',

  'property.message': 'Viesti',
  'property.example': 'Esimerkki',
  'property.link': 'Linkit',
  'property.image-carousel': 'Kuvakaruselli',
  'property.Title': 'Otsikko',
  'property.SubTitle': 'Alaotsikko',

  'property.add-invoke-api': 'Kutsu Api',
  'property.add-message-button': 'Lisää viestejä',
  'property.add-img-button': 'Lisää kuvia',
  'property.add-link-button': 'Lisää linkki',
  'property.add-herocard-button': 'Lisää sankarikortti',
  'property.add-api-button': 'Lisää painikkeita',

  'menu.settings': 'Asetukset',
  'menu.workflows': 'Työnkulut',
  'menu.product_services': 'Tuotteet ja palvelut',
  'menu.product_recommander': 'Tuotesuositin',
  'menu.digital_guide_book': 'Digitaalinen opaskirja',
  'menu.welcome_message': 'Tervetuloviesti',
  'menu.about-property': 'Tietoa kohteesta',
  'menu.property-facilities': 'Kohteen palvelut',
  'menu.room-amenities': 'Huoneen varustelu',
  'menu.property-contact': 'Yhteystiedot',
  'menu.about-rooms': 'Huoneet',
  'menu.special-emergencies': 'Hätätilanteet',
  'menu.show-filter': 'Suodattimet',
  'menu.new': 'Uusi',
  'menu.channel': 'Kanavat',
  'menu.application': 'Sovellukset',

  'dashboards.send': 'Lähetä',
  'dashboards.hello': 'Hei',
  'dashboards.notificationsAllowed': 'Ilmoitukset sallittu',
  'dashboards.allowNotifications': 'Salli ilmoitukset',
  'dashboards.views': 'Näyttökerrat',
  'dashboards.bookingURL': 'Varaus-URL',
  'dashboards.searchTags': 'Hakutunnisteet',
  'dashboards.searchCategoryTags': 'Hakukategorian tunnisteet',
  'dashboards.bedroom': 'Makuuhuone',
  'dashboards.addBedroom': 'Lisää makuuhuone',
  'dashboards.frequency': 'Tiheys',
  'dashboards.includeSubpages': 'Sisällytä alasivut',
  'dashboards.enableFaqs': 'Ota FAQ käyttöön',
  'dashboards.faqsDescription': 'Kun otat FAQ‑t käyttöön, voit syöttää kysymyksiä samalla kun järjestelmä poimii niihin liittyviä vastauksia verkkosivun sisällöstä luodakseen täydelliset FAQ‑t',
  'dashboards.faq': 'FAQ',
  'dashboards.deleteDocument': 'Poista asiakirja',
  'dashboards.confirmDelete': 'Oletko varma, että haluat poistaa?',
  'dashboards.addItem': 'Lisää kohde',
  'dashboards.addFirstWebPage': 'Lisää ensimmäinen verkkosivusi',

  'dashboards.popular-compendium': 'Suositut koontivalikon kohteet',
  'dashboards.wordcloudofcompendium': 'Sanapilvi koontivalikon kohteista',
  'dashboards.wordcloudonthings': 'Sanapilvi aiheista, joista verkkosivuvierailijat kysyvät ja valikkokohteista',
  'dashboards.common-asked': 'Usein kysytyt kysymykset',
  'dashboards.website-visitor-asking':
    'Asiat, joista sivuston vierailijat kysyvät',
  'dashboards.visit-country': 'Sivustovierailu maittain',
  'dashboards.visit-traffic': 'Sivuston liikenteen maa',
  'dashboards.rooms-product': 'Huoneet ja tuotteet',
  'dashboards.popular-room-product': 'Suosittuja huoneita ja tuotteita',

  'dashboards.messenger-stats': 'Suositut valikkokohdat',
  'dashboards.messenger-stats-topic-view':
    'Tilastot valikon kohteiden näkymistä',
  'dashboards.messenger-stats-visits': 'Valikkokohteiden näkymät',
  'dashboards.opening-menu-items':
    'Niiden verkkosivuston vierailijoiden määrä, jotka avaavat valikon kohteita',
  'dashboards.connect': 'Yhdistä',

  'dashboards.number-totalavatarclick': 'Avatar-klikkaukset yhteensä',
  'dashboards.tickets-by-category': 'Liput kategorioittain',
  'dashboards.download': 'Lataa',
  'dashboards.clicks': 'Napsautukset',
  'dashboards.leads': 'Johtoja',
  'dashboards.hours': 'Tuntia',
  'dashboards.minutes': 'Pöytäkirja',
  'dashboards.subscribe-to-reports': 'Tilaa raportit',
  'dashboards.ai-chatbot': 'AI Chatbot',
  'dashboards.compendium': 'Compendium',
  'dashboards.compendium-digital-usage': 'Digitaalisen kokoelman käyttö',
  'dashboards.compendium-unique-visits': 'QR-koodien skannaukset/klikkaukset',
  'dashboards.compendium-opening-menu-items':
    'Katsottujen valikkokohtien määrä',
  'dashboards.compendium-total-digital-clicks':
    'Valikkokohdan katselukertojen kokonaismäärä',
  'dashboards.compendium-total-qr-code': 'QR-koodien skannaukset/klikkaukset yhteensä',
  'dashboards.compendium-avg-menu-items': 'Keskimääräinen valikkokohdan katselukertojen määrä skannausta kohden',


  'property.delete': 'Poistaa',
  'menu.userroles': 'Käyttäjät ja roolit',
  'menu.members': 'Mga miyembro',
  'menu.guest-pass': 'Vieraspassi',
  'menu.ratebookings': 'Hinnat ja varaukset',
  'dashboards.engagement-time': 'Digital Assistantin sitoutumisaika',
  'dashboards.conversations-minutes':
    'Minuutit ja yön yli (klo 19–7) keskusteluminuutit yhteensä',
  'dashboards.visitor-questions': 'Vierailijan kysymykset',
  'dashboards.recent-queries': 'Viimeaikaiset kyselyt',
  'dashboards.visitor-saying':
    'Mitä vierailijasi sanovat Digital Assistantille',
  'dashboards.contacts-prechatform-leavemessage':
    'Tallennetut yhteystiedot Pre Chat -lomakkeesta ja jätä viesti',
  'menu.dashboards': 'Näkemyksiä',
  'menu.ari': 'Saatavuus ja hinnat',
  'menu.conversations': 'Keskustelut',
  'menu.conversations.unified-inbox': 'Yhdistetty postilaatikko',
  'menu.conversations.active': 'Aktiiviset keskustelut',
  'menu.conversations.archives': 'Arkistot',
  'menu.conversations.missed-responses': 'Jääneet vastaukset',
  'menu.conversations.ticket': 'Liput',
  'menu.conversations.reply-templates': 'Vastausmallit',
  'menu.bookings': 'Varaukset ja varaukset',
  'menu.tickets': 'Johdot ja liput',
  'menu.propinfo': 'Knowledge Hub',
  'menu.rate-promos': 'Hinnat ja tarjoukset',
  'menu.finance': 'Rahoittaa',
  'menu.integration': 'Kytkeä',
  'menu.admin': 'Järjestelmänvalvoja ja suojaus',
  'menu.favourites': 'Suosikit',
  'menu.recommender': 'Keskustelukulku',
  'menu.assistant-setup': 'Assistantin asetukset',
  'menu.admin-insights': 'Admin Insights',
  'menu.super-admin': 'Super Admin',
  'menu.groups': 'ryhmät',
  'menu.properties': 'Ominaisuudet',
  'menu.service-provider': 'Palveluntarjoajat',
  'menu.spaces': 'Spaces',
  'menu.content-manager': 'Sisällönhallinta',
  'menu.events-calendar': 'Tapahtumakalenteri',
  'menu.appearance-settings': 'Ulkoasu ja asetukset',
  'menu.availability': 'Saatavuus',
  'menu.help': 'Apua',
  'menu.myAccounts': 'Omat tilit',
  'menu.guest-messaging': 'Vierasviestintä',
  'guest-messaging.settings': 'Asetukset',
  'guest-messaging.outreach-setup': 'Tiedotuskampanjat',
  'guest-messaging.reservations': 'Varaukset',
  'guest-messaging.insights_logs': 'Analyysit ja lokit',
  'guest-messaging.placeholder': 'Vierasviestintämoduuli tulossa pian.',
  'guest-messaging.settings.placeholder': 'Aseta vierasviestintäasetukset.',
  'guest-messaging.outreach.placeholder': 'Aseta tiedotuskampanjat ja mallipohjat.',
  'guest-messaging.reservations.placeholder': 'Hallinnoi varausten viestejä.',
  'guest-messaging.reservation-source': 'Varausdatan lähde',
  'guest-messaging.communication-channels': 'Viestintäkanavat',
  'guest-messaging.templates': 'Mallipohjat',
  'guest-messaging.link': 'Linkki',
  'guest-messaging.business-profile': 'Yritysprofiili',

  'dashboards.space-booking': 'Tilavaraus',
  'dashboards.gift-voucher': 'Lahjakortit',
  'dashboards.chatbots': 'Chatbotit',
  'dashboards.form': 'From',
  'dashboards.to': 'Vastaanottaja',
  'dashboards.active-groups': 'Aktiiviset ryhmät',
  'dashboards.active-properties': 'Aktiiviset ominaisuudet',
  'dashboards.live-properties': 'Live-ominaisuudet',
  'dashboards.properties-going': 'Kiinteistöt julkaistaan ​​ajanjakson mukaan',
  'dashboards.start-date': 'Aloituspäivämäärä',
  'dashboards.end-date': 'Päättymispäivämäärä',

  'dashboards.website-visits': 'Vierailut verkkosivuilla',
  'dashboards.unique-visitors': 'Ainutlaatuiset Vierailijat',
  'dashboards.last-week': 'Viime viikko',
  'dashboards.this-week': 'Tämä viikko',
  'dashboards.this-month': 'Tässä kuussa',
  'dashboards.previous-month': 'Edellinen kuukausi',
  'dashboards.yeartodate': 'Päivälleen vuosi',
  'dashboards.lastyear': 'Viime vuonna',
  'dashboards.last-7-days': 'Viimeiset 7 päivää',
  'dashboards.last-30-days': 'Viimeiset 30 päivää',
  'dashboards.last-60-days': 'Viimeiset 60 päivää',
  'dashboards.last-90-days': 'Viimeiset 90 päivää',
  'dashboards.conversion-rates': 'Muuntokurssit',
  'dashboards.digital-assistant-engagement': 'Digital Assistant Engagement',
  'dashboards.total-overnight-conversations':
    'Yhteensä ja yön yli (klo 19–7) keskustelut',
  'dashboards.percentage-accuracy': 'Tarkkuuden ymmärtäminen',
  'dashboards.percentage-conversion': 'Verkkosivuston liikenne chat-muunnos',
  'dashboards.percentage-avatarclick':
    'Verkkosivuston liikenne avatar-napsautuksiin',
  'dashboards.percentage-negativefeedback':
    'Negatiivinen palaute avatar-napsautusten prosentteina',
  'dashboards.percentage-amenties': 'Palvelukyselyt',
  'dashboards.percentage-booking': 'Varauskyselyt',
  'dashboards.percentage-webchats': 'Verkkosivuston chatit',
  'dashboards.percentage-facebookchat': 'Facebook-chatit',
  // 'dashboards.number-webchattime': 'Total Web Chat Time',
  'dashboards.number-webchattime': 'Koko keskusteluaika',
  'dashboards.number-totalconversation': 'Keskustelut yhteensä',
  'dashboards.number-websiteconversation': 'Verkkosivuston keskustelut',
  'dashboards.number-facebookconversation': 'Facebook-keskustelut',
  'dashboards.number-estimatedtimesaving': 'Arvioitu ajansäästö',
  'dashboards.number-googlemapsconversation': 'Google Maps -keskustelut',
  'dashboards.number-whatsappconversation': 'WhatsApp-keskustelut',
  'dashboards.number-instagramconversation': 'Instagram-keskustelut',
  'dashboards.number-agentconversation': 'Agentin keskustelut',
  'dashboards.number-amenityqueries': 'Palvelukyselyt',
  'dashboards.number-bookingenquiries': 'Varauskyselyt',
  'dashboards.number-groupbookingenquiries': 'Ryhmävarauskyselyt',
  'dashboards.number-eventenquiries': 'Tiedustelut tapahtumista',
  'dashboards.number-longstayenquiries': 'Pitkän oleskelun tiedustelut',
  'dashboards.number-totaltickets': 'Liput',
  'dashboards.number-returncustomer': 'Paluuasiakas',
  'dashboards.number-redirects': 'Verkkosivustojen uudelleenohjaukset',
  'dashboards.number-bookingengineleads': 'Moottorin johtojen varaus',
  'dashboards.number-roomnightsreferred': 'Viitetyt huoneyöt',
  'dashboards.number-revenuereferred': 'Viitattu tulo',
  'menu.bookingsmenu': 'Varaukset',
  'menu.guests': 'Vieraiden tiedot',
  'menu.whatsnew': 'Mikä on uutta',
  'dashboards.welcomeMessage': 'Tervetuloviesti',
  'dashboards.personalizeGreeting': 'Personoi asiakastervehdys brändisi, tyylisi ja etikettisi mukaiseksi varmistaaksesi lämpimän vastaanoton. Mukauta tervehdykset heijastamaan brändiäsi ja luomaan lämmin tunnelma.',
  'dashboards.addRoomDetails': 'Lisää tietoja jokaisesta huoneestasi, jotta vieraat voivat helposti löytää kaiken tarvitsemansa valitakseen täydellisen vaihtoehdon ja tehdä varausprosessista yksinkertaisemman ja nopeamman.',
  'dashboards.trainAIFAQs': 'Kouluta tekoäly FAQ-tietojen avulla',
  'dashboards.manualQuestions': 'Joihinkin kysymyksiin ei voi saada vastausta dokumenteista eikä niitä löydy verkkosivustolta. Tässä voit lisätä kysymyksiä manuaalisesti varmistaaksesi, että asiakkailla on aina tarvitsemansa tiedot saatavilla.',
  'dashboards.publishAI': 'Julkaise tekoäly heijastamaan viimeisimmät päivitykset',
  'dashboards.retrainAfterChanges': 'Kun teet muutoksia Knowledge Hubissa tai lomakkeissa, varmista, että koulutat chatbotin uudelleen päivitettyjen tietojen kanssa. Tekoälyn julkaisu varmistaa, että chatbot antaa tarkimmat ja ajan tasalla olevat vastaukset.',
  'dashboards.enhanceKnowledge': 'Laajenna tekoälyn tietämystä seuraamalla vastaamattomia kyselyjä',
  'dashboards.reviewUnanswered': 'Aina kun tekoäly ei pysty vastaamaan kysymykseen tai antaa vain rajallisia tietoja, löydät nämä kyselyt täältä. Tarkastele niitä tunnistaaksesi aukot Knowledge Hubissasi tai ainutlaatuisissa vieraskysymyksissä.',
  'dashboards.manageMedia': 'Hallinnoi mediaa',
  'dashboards.mediaGallery': 'Kun lataat kuvia kuten huoneista, mukavuuksista, logoista tai digitaalisesta avataristasi, ne tulevat näkyviin tässä galleriassa. Saat keskeisen paikan visuaalien hallintaan ja varmistat, että vieraasi näkevät, mikä tekee liiketoiminnastasi ainutlaatuisen.',
  'dashboards.createForms': 'Luo lomakkeita helposti ja saa ilmoitus jokaisesta lähetetystä vastauslomakkeesta.',
  'dashboards.manageForms': 'Luo ja hallinnoi lomakkeita asiakastietojen keräämiseen, ilmoitusten asetuksiin ja mukauta ne eri kielille.',
  'dashboards.personalizeResponse': 'Personoi vastaustyyli ja miten keskustelu etenee',
  'dashboards.controlConversation': 'Tämä kehittynyt ominaisuus antaa sinulle mahdollisuuden muokata ja hallita, miten keskustelut kehittyvät asiakkaidesi kanssa eri kanavissa.',

  'menu.formbuilder': 'Lomakkeiden rakentaja',
  'forms.forms-title': 'Lomakkeet',
  "dashboards.trainAI": "Kouluta tekoälyä asiakirjoilla",
  "dashboards.uploadDocuments": "Lataa asiakirjoja, jotta tekoälysi oppii tuntemaan yrityksesi ja auttamaan asiakkaita kuten sinäkin. Voit lisätä tiedostoja .doc-, .pdf- tai .txt-muodossa.",
  'menu.virtualfrontdesk': 'Virtuaalinen vastaanotto',
  'menu.guestservice': 'Vieraspalvelut',
  'virtual-front.common-questions': 'Yleisiä kysymyksiä',
  'virtual-front.add-on-upsells': 'Lisäosat ja lisämyynti',
  'virtual-front.service-order': 'Palvelutilaukset',
  // 'virtual-front.guest-service-add-on-upsells': "Guest Services & Add-on's",
  'virtual-front.guest-service-add-on-upsells': 'Digitaalinen vieraskirja',
  'virtual-front.outbound': 'Lähtevä',
  'virtual-messenger': 'sanansaattaja',

  'missed-response.missed-response-title': 'Unohtunut vastauksen otsikko',
  //unified-inbox
  'content.allconversation': 'Kaikki keskustelut',
  'content.active': 'Aktiivinen',
  'content.tickets': 'Tiketit',
  'content.filter': 'Suodata',
  'content.createtickets': 'Luo tiketti',
  'content.conversation': 'Keskustelu',
  'content.knowledgesearch': 'Tietohaun',
  'content.reply': 'Vastaa',
  'content.visitorinfo': 'Vierailijan tiedot',
  'content.callinfo': 'Puhelutiedot',
  'content.allinsights': 'Kaikki oivallukset',
  'content.availabilityrates': 'Saatavuus ja hinnat',
  'content.callback': 'Takaisinsoitto',
  'content.close': 'Sulje',
  'content.sms': 'Tekstiviesti',
  'content.timestamp': 'Aikaleima',
  'content.topics': 'Aihealueet',
  'content.callingparty': 'Soittava osapuoli',
  'content.accountdomain': 'Tilin verkkotunnus',
  'content.calledparty': 'Vastaanottava osapuoli',
  'content.recording': 'Tallennus',
  'content.phonesystemoriginationcallid': 'Puhelinjärjestelmän lähtevän puhelun tunnus',
  'content.phonesystemterminationcallid': 'Puhelinjärjestelmän päättyvän puhelun tunnus',
  'content.uniqueconversationid': 'Yksilöllinen keskustelutunnus',
  'content.regenerateinsights': 'Luo oivallukset uudelleen',
  'content.customersentiment': 'Asiakastunne',
  'content.neutral': 'Neutraali',
  'content.customerreportedbroadbandoutage': 'Asiakas ilmoitti laajakaistahäiriöstä ja antoi asiakastunnuksen ja palvelun aktivointipäivän saadakseen apua.',
  'content.conversationinsights': 'Keskustelun oivallukset',
  'content.broadbandoutage': 'Laajakaistahäiriö',
  'content.customeridverification': 'Asiakastunnuksen vahvistus',
  'content.serviceactivationdate': 'Palvelun aktivointipäivä',
  'content.followups': 'Jatkotoimet',
  'content.actionneeded': 'Toimenpiteitä vaaditaan',
  'content.uniqueConversationId': 'Ainutlaatuinen keskustelu‑ID',
  'content.uniqueChatId': 'Ainutlaatuinen chat‑ID',
  'content.recording&transcript': 'Tallennus ja transkriptio',
  'content.chatinsights': 'Chat‑näkymät',
  'content.visitedpages': 'Käydyt sivut',
  'content.deviceinfo': 'Laitetiedot',
  'content.chatstartedonthispage': 'Chat aloitettiin tällä sivulla',
  'content.prechatinfo': 'Ennakkotiedot ennen chattia',
  'content.notes': 'Muistiinpanot',
  'content.reassign': 'Uudelleen määritä',
  'content.open': 'Avaa',
  "content.dismiss": "Sulje",
  "content.add_placeholder": "Lisää paikkamerkkiarvot",
  "content.mobile_number": "Matkapuhelinnumero",
  "content.please_select": "Valitse",
  'content.sendwhatsapp': 'Lähetä WhatsApp-viesti',



  /* Missed Response */
  'feedback.missed-question': 'Vastaamaton kysymys',
  'feedback.conversation-summary': 'Keskustelun yhteenveto',
  'feedback.dates-in-spanish': 'Päivämäärien tulee olla espanjaksi',
  'feedback.resolve': 'Ratkaise',
  'feedback.ignore': 'Ohita',
  //integration
  // fi-FI
  'integration.select_properties': 'Valitse ominaisuudet',
  'integration.select_properties_enabled': 'Valitse tämän integraation kautta aktivoidut ominaisuudet',
  'integration.services_addons': 'Valitse palvelut ja lisäosat',
  'integration.services_visible': 'Valitse, mitkä palvelut ja lisäosat näkyvät tällä sivulla',
  'integration.appearance': 'Ulkoasu',
  'integration.appearance_customize': 'Valitse digitaalisen avustajasi nimi, profiilikuva ja määritä värit',
  'integration.booking_calendar': 'Varauskalenteri',
  'integration.booking_calendar_style': 'Valitse varausskalenterin ponnahdusikkunan tyyli',
  'integration.nudges': 'Ohjaukset',
  'integration.nudges_setup': 'Aseta proaktiivisia viestejä sitouttamaan verkkosivun kävijöitä',
  'integration.position': 'Sijainti',
  'integration.position_control': 'Ohjaa chat-widgetin sijaintia verkkosivustollasi',
  'integration.custom_fonts': 'Mukautetut fontit',
  'integration.custom_fonts_upload': 'Lataa käyttöösi mukautettuja fontteja sivua varten',
  'integration.custom_css': 'Mukautettu CSS',
  'integration.custom_css_usage': 'Käytä CSS:ää Digital Compendium -sivun muokkaamiseen',
  'integration.location': 'Sijainti',
  'integration.location_embed': 'Lisää upotuksen sijainti-URL',
  'integration.external_links': 'Ulkoiset linkit',
  'integration.external_links_add': 'Lisää linkkisi',
  'integration.language': 'Kieli',
  'integration.widget_languages': 'Valitse chat-widgetin kielet',
  'integration.chatbot_contact': 'Chatbot',
  'integration.chatbot_enable': 'Ota digitaalinen avustajasi käyttöön',
  'integration.chatbot_security': 'Pidä Messengerisi suojattuna',
  'integration.chatbot_trusted_pages': 'Luettele luotetut sivut, joissa Chatbot näkyy',
  'integration.chatbot_publish': 'Julkaise digitaalinen avustajasi',
  'integration.chatbot_install': 'Kopioi koodinpätkä avustajan asentamiseksi',

};
export default fiMessages;